<template>
  <v-dialog
      v-model="value"
      persistent
      :max-width="maxWidth"
      >
      <v-card
               
      >
          <v-card-title
            class="text-h5 py-0"
          >
            {{title}}
          </v-card-title>

          <v-card-text
            style="min-height: 500px;"
          >
            <filter-detail
              v-if="selectedFilter"
              :filter="selectedFilter"
              :pod="pod"
              :group_id="group_id"
              :key="`filterdetail_${selectedFilter.id}`"
              :reload="reloadFilter"
              :messageFields="allMessageFields"
              @changed="filterChanged"
              @fieldChanged="fieldChanged"
              @operatorChanged="operatorChanged"
              :disabled="disabled"
            />

            <filter-list
              v-else
              :filters="filters"
              @select="doSelect"
              :refresh="refreshList"
            />
    
          </v-card-text>
          <v-card-actions>
            
              <v-btn
                @click="doNew()"
                v-if="(!disabled) && (selectedFilter ? false : true)"
              >
                New Filter
              </v-btn>   

            <v-spacer></v-spacer>
              <v-btn
                @click="save()"
                v-if="state.startsWith('detail')"
                :disabled="saveDisabled"
                :loading="saving"
                width="80"
              >
                Save
              </v-btn>              


              <v-btn
                @click="cancel()"
                width="80"
              >
                {{cancelCaption}}
              </v-btn>              

          </v-card-actions>          
      </v-card>

  </v-dialog>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import scheduleFilterList from '@/views/apps/scheduling-new/components/scheduleFilterList';
import scheduleFilterDetail from '@/views/apps/scheduling-new/components/scheduleFilterDetail';

  export default {
    props: {
      value: {
        default: false,
        type: Boolean
      },
      'max-width': {
        default: '500',
        type: String
      },
      filters: {
          type: Array,
          default: () => []
      },      
      title: {
        default: 'Shifts',
        type: String
      },
      facilities: {
          type: Array,
          default: () => []
      }, 
      pod: {
          type: Object,
          default: () => {}
      }, 
      group_id: {
          type: String,
          default: ''
      }, 
      calendar_date: {
          type: String,
          default: ''
      },     
      refreshList: {
        default: '',
        type: String
      },  
      disabled: {
        default: false,
        type: Boolean
      },                               
    },
    components: {
        'filter-list': scheduleFilterList,   
        'filter-detail': scheduleFilterDetail
    },    
    data: () => ({
      selectedFilter: null,
      filterEdits: {},
      reloadFilter: null,
      saving: false,
      messageEdits: {},
      operatorEdits: {}
    }),
    mounted() {
    },
    methods: {
      ...mapActions('schedule',['saveShift']),
      hasFieldChanged(id, answer){

        let field
        if (this.selectedFilter && this.selectedFilter.message_fields) {
          field = this.selectedFilter.message_fields.find(f => {
            return f.id === id
          })
        }

        if (!field) {
          return true
        }
        let value = JSON.parse(field.value_json)
        if (Array.isArray(value)) {
          return this.arrayString(value) !== this.arrayString(answer)
        } else {
          return value !== answer
        }
      },
      hasOperatorChanged(id, operator) {

        let field
        if (this.selectedFilter && this.selectedFilter.message_fields) {
          field = this.selectedFilter.message_fields.find(f => {
            return f.id === id
          })
        }

        if (!field) {
          return true
        }
        return this.translateOperator(field.operator) !== this.translateOperator(operator)
      },

      translateOperator (operator) {
        switch (operator) {
          case '$in':
          case '$eq': //We will set these based on the number of locations
            return '$in'
          case '$nin':
          case '$neq': //We will set these based on the number of locations
            return '$nin'
        }
        return null
      },      
      arrayString(arr) {   

        if (!arr) {
          arr = []
        }     
        let temp = JSON.parse(JSON.stringify(arr))

        let temp2 = temp.sort()
        
        return temp2.join(',')
      },

      fieldChanged (fields) {

        for (let field in fields) {
          this.$set(this.messageEdits,field,fields[field])
        }

      },
      operatorChanged(fields) {

        for (let field in fields) {
          this.$set(this.operatorEdits,field,fields[field])
        }

      },
      filterChanged (props) {

        for (let prop in props) {
          
          switch (prop) {
            //case 'rounding_outpatient':

              //break
            default:
              this.$set(this.filterEdits,prop,props[prop])
              break
          }
        }

      },
      doSelect (filter) {

        this.selectedFilter = filter

        this.filterEdits = {}
        this.messageEdits = {}
        this.operatorEdits = {}
      },
      doNew () {

        this.selectedFilter = {
          user_id: this.group_id
        }
        this.filterEdits = {}
        this.messageEdits = {}
        this.operatorEdits = {}
      },
      cancel () {

        if (this.state === 'detail_dirty') {
          this.filterEdits = {}
          this.messageEdits = {}
          this.operatorEdits = {}
          this.reloadFilter = (new Date()).toISOString()
        } else if (this.state === 'detail') {
          this.selectedFilter = null
        } else {
          this.$emit('input', false)          
        }
      },
      saveFinished (success)  {

        if (success) {
          this.reloadFilter = (new Date()).toISOString()
          this.selectedFilter = null
        }
        this.saving = false
      },
      async save () {

        this.saving = true

        let params
        if (this.selectedFilter.id) {
          params = JSON.parse(JSON.stringify(this.filterEdits))

          params.id = this.selectedFilter.id

          params.callback = this.saveFinished
        } else {
          params = JSON.parse(JSON.stringify(this.selectedFilter))

          for (let prop in this.filterEdits) {
            params[prop] = this.filterEdits[prop]
          }


          params.callback = this.saveFinished

        }
        params.group_id = this.group_id
        /*
        let fieldMap = {}
        this.allMessageFields.map(f => {
          fieldMap[f.id] = f
        })
        */         
        for (let id in this.messageEdits) {
          let answer = this.messageEdits[id]

          if (this.hasFieldChanged(id, answer)) {
            params[`field_${id}.value`] = JSON.stringify(answer)
          }
        }
        for (let id in this.operatorEdits) {
          let operator = this.operatorEdits[id]
          if (this.hasOperatorChanged(id, operator)) {
            params[`field_${id}.operator`] = operator
          }
        }

        this.$emit('saveFilter', params)
      },      
    },
    computed: {
      allMessageFields() {
        let obj = this.$store.getters['schedule/getGroupById'](this.group_id)
        if (obj) {
          return obj.fields
        }
        return []
      }, 
      saveDisabled () {

        if (!this.selectedFilter.id) {


          if (!this.filterEdits.name) {
            return true
          }

          return false

        }
        return this.state !== 'detail_dirty'
      },
      state () {

        if (!this.selectedFilter) {
          return 'list'
        } else {

          if (this.filterDirty) {

            return 'detail_dirty'
          } else {

            return 'detail'
          }
        }        
      },
      cancelCaption () {
        switch (this.state) {
          case 'detail':
            return 'Back'
          case 'detail_dirty':
            return 'Cancel'
          default:
            return 'Close'          
        }
      },
      filterDirty () {
        
        let dirty = false
        let temparr
        let originalString
        let editingString

        let opOriginal
        let opNew

        let value2

        for (let prop in this.filterEdits) {


          if (prop.startsWith('default_options')) {

            let editing = this.filterEdits[prop]
            let pieces = prop.split('.')

            let option

            if (this.selectedFilter.default_options) {
              option = this.selectedFilter.default_options.find(o => {
                return o.id === pieces[1]
              })
            }

            let value

            if (option) {
              value = JSON.parse(option.value_json)
            }

            switch (pieces[1]) {
              case 'location':
                
                if (pieces[2] === 'value') {
                  temparr = []
                  if (value && Array.isArray(value)) {
                    value.map(v => {
                      if (!v.unit) {
                        temparr.push(v.facility)
                      } else {
                        temparr.push(`${v.facility}|${v.unit}`)
                      }
                    })
                  }

                  originalString = this.arrayString(temparr)
                  editingString =  this.arrayString(editing)
                  if (originalString !== editingString) {
                    return true
                  }

                } else if (pieces[2] === 'operator') {
                  
                  if (option) { //if no option then opeerator doesn
                    opOriginal = this.translateOperator(option.operator)
                  }
                  opNew = this.translateOperator(editing)

                  let value2 = this.filterEdits['default_options.location.value']

                  if (!value2) {
                    if (option) {
                        value2 = JSON.parse(option.value_json)
                    } else {
                      value2 = []
                    }
                  }
                  

                  if (value2.length) {
                    // operator is only important if the array has a length

                    if (opOriginal !== opNew) {
                      return true
                    }
                  }
                  
                }
                break

              case 'patient_status':
                
                if (value) {
                  if ( value !== editing){
                    return true
                  }
                } else {
                  if (editing) {
                    return true
                  }  
                }
                break


              case 'patient':
                
                if (pieces[2] === 'value') {

                  originalString = this.arrayString(value)
                  editingString =  this.arrayString(editing)
                  if (originalString !== editingString) {
                    return true
                  }

                } else if (pieces[2] === 'operator') {
                  
                  if (option) { //if no option then opeerator doesn
                    opOriginal = this.translateOperator(option.operator)
                  }
                  opNew = this.translateOperator(editing)

                  let value2 = this.filterEdits['default_options.location.value']

                  if (!value2) {
                    if (option) {
                        value2 = JSON.parse(option.value_json)
                    } else {
                      value2 = []
                    }
                  }
                  

                  if (value2.length) {
                    // operator is only important if the array has a length

                    if (opOriginal !== opNew) {
                      return true
                    }
                  }
                  
                }
                break

              case 'priority':

                if (!option) {
                  if (editing === 'yes') {
                    return true
                  }
                }

                if (editing !== value) {
                  return true
                }

                break

              case 'calltype':

                if (pieces[2] === 'value') {

                  originalString = this.arrayString(value)
                  editingString =  this.arrayString(editing)
                  if (originalString !== editingString) {
                    return true
                  }

                } else if (pieces[2] === 'operator') {

                  if (option) { //if no option then opeerator doesn
                    opOriginal = this.translateOperator(option.operator)
                  }
                  opNew = this.translateOperator(editing)

                  let value2 = this.filterEdits['default_options.location.value']

                  if (!value2) {
                    if (option) {
                        value2 = JSON.parse(option.value_json)
                    } else {
                      value2 = []
                    }
                  }
                  

                  if (value2.length) {
                    // operator is only important if the array has a length

                    if (opOriginal !== opNew) {
                      return true
                    }
                  }
                  
                }
                break                

            }
          } else {

            switch (prop) {
              case 'name':

                  editingString = this.filterEdits[prop]

                  if (this.selectedFilter.name !== editingString) {
                    return true
                  }


                break
              case 'user_id':

                  editingString = this.filterEdits[prop]

                  if (this.selectedFilter.name !== editingString) {
                    return true
                  }


                break                
            }
          }

        }


        let originalAnswers = {}
        let originalOperators = {}

        if (this.selectedFilter.message_fields && this.selectedFilter.message_fields.length) {

          this.selectedFilter.message_fields.map(f => {
            let value = JSON.parse(f.value_json)
            originalAnswers[f.id] = Array.isArray(value) ? this.arrayString(value) : value
            originalOperators[f.id] = f.operator
          })
        }

        this.allMessageFields.map(field => {
          let edit = this.messageEdits[field.id]

          if (edit) {

            let compare = Array.isArray(edit) ? this.arrayString(edit) : edit
            
            if (compare != originalAnswers[field.id]) {

              dirty = true
            }
          }

          let editOperator = this.operatorEdits[field.id]

          if (editOperator) {
            let compareOp = this.translateOperator(editOperator)
            
            if (compareOp != this.translateOperator(originalOperators[field.id])) {

              dirty = true
            }

          }
        })

        return dirty
      },

    },
    watch: {
        value (newValue, oldValue) {
          this.selectedFilter = null
        },
    }
  }
</script>

